exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-actionStatus{position:absolute;left:-999em}", ""]);

// exports
